// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html:has(.admin-dashboard-shell),
body:has(.admin-dashboard-shell) {
  margin: 0;
  overflow: hidden;
  height: 100%;
}

.admin-home-root {
  width: 100%;
  height: 100%;
}

.admin-dashboard-shell {
  --ops-sidebar-width: 280px;
  position: fixed;
  inset: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f1eb 0%, #f8f7fb 30%, #eef4ff 100%);
  padding: 28px 32px;
  overflow: hidden;
}

.admin-dashboard-backdrop {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at top left, rgba(245, 193, 193, 0.35), transparent 28%),
    radial-gradient(circle at bottom right, rgba(175, 211, 255, 0.28), transparent 30%);
  pointer-events: none;
}

.admin-dashboard-header,
.admin-dashboard-content,
.admin-footer {
  position: relative;
  z-index: 1;
}

.admin-dashboard-header {
  --admin-brand-logo-width: 160px;
  width: 100%;
  flex: 0 0 auto;
  margin: 0 0 12px;
  padding: 0;
  display: grid;
  grid-template-columns: var(--ops-sidebar-width, 280px) minmax(0, 1fr);
  gap: 14px;
  align-items: center;
}

.admin-brand-logo-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.admin-brand-logo {
  width: var(--admin-brand-logo-width);
  height: auto;
  flex: 0 0 auto;
  opacity: 0.95;
}

.admin-brand-label {
  justify-self: start;
  display: inline-flex;
  align-items: center;
  padding: 9px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(152, 163, 192, 0.22);
  color: #6a6283;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  backdrop-filter: blur(10px);
}

.logout-button {
  border: none !important;
  background: linear-gradient(135deg, #f2c4c4, #f9e1be) !important;
  color: #2d2b36 !important;
  border-radius: 999px !important;
  padding: 12px 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 10px !important;
  box-shadow: 0 10px 20px rgba(245, 180, 180, 0.28) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.logout-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 24px rgba(245, 180, 180, 0.34) !important;
}

.admin-dashboard-content {
  width: 100%;
  flex: 1 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-dashboard-content > .ops-layout {
  flex: 1 1;
  min-height: 0;
  height: 100%;
}

.admin-welcome-panel {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(143, 155, 175, 0.18);
  border-radius: 28px;
  padding: 32px 36px;
  box-shadow: 0 20px 50px rgba(52, 62, 94, 0.08);
  backdrop-filter: blur(12px);
}

.welcome-badge {
  display: inline-block;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(213, 204, 253, 0.45);
  color: #4d4a68;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.admin-welcome-panel h1 {
  margin: 0;
  font-size: clamp(2.2rem, 3vw, 3.4rem);
  line-height: 1.1;
  letter-spacing: -0.04em;
  color: #1f2430;
}

.admin-welcome-panel p {
  margin: 14px 0 0;
  color: #5e6475;
  font-size: 1.02rem;
  max-width: 720px;
  line-height: 1.7;
}

.admin-stats-row {
  margin-top: 26px;
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 18px;
}

.admin-stat-card {
  background: rgba(255, 255, 255, 0.76);
  border: 1px solid rgba(143, 155, 175, 0.15);
  border-radius: 22px;
  padding: 20px 22px;
  box-shadow: 0 12px 26px rgba(58, 67, 88, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;
}

.admin-stat-card span {
  color: #6b728a;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.admin-stat-card strong {
  margin-top: 12px;
  font-size: clamp(1.7rem, 2vw, 2.6rem);
  color: #171d2c;
  letter-spacing: -0.04em;
}

.admin-modules-section {
  margin-top: 34px;
}

.admin-modules-heading h2 {
  margin: 0;
  font-size: 1.35rem;
  color: #1f2430;
  letter-spacing: -0.02em;
}

.admin-modules-heading p {
  margin: 6px 0 0;
  color: #7a758c;
  font-size: 0.95rem;
}

.admin-card-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.admin-module-card {
  display: flex;
  align-items: center;
  gap: 18px;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(143, 155, 175, 0.15);
  border-radius: 24px;
  padding: 18px 18px 18px 16px;
  text-decoration: none;
  box-shadow: 0 18px 32px rgba(32, 40, 56, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  min-height: 120px;
}

.admin-module-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 22px 36px rgba(32, 40, 56, 0.12);
  text-decoration: none;
}

.admin-module-icon {
  width: 62px;
  height: 62px;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  box-shadow: inset 0 1px 1px rgba(255,255,255,0.25), 0 10px 18px rgba(0,0,0,0.08);
}

.admin-module-icon i {
  font-size: 1.7rem;
  color: #ffffff;
}

.admin-module-text {
  flex: 1 1;
  min-width: 0;
}

.admin-module-text h3 {
  margin: 0 0 6px;
  font-size: 1.12rem;
  color: #1f2430;
  font-weight: 700;
  line-height: 1.3;
}

.admin-module-text p {
  margin: 0;
  font-size: 0.78rem;
  color: #757d8b;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.admin-module-arrow {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f9;
  color: #32384a;
  font-size: 0.9rem;
  bottom: 0;
}

.admin-footer {
  max-width: 1320px;
  margin: 0 auto;
  padding: 10px 0 16px;
  text-align: center;
}

.admin-footer p {
  margin: 0;
  color: #6c757d;
  font-size: 0.85rem;
}

@media (max-width: 1100px) {
  .admin-dashboard-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 14px;
  }

  .admin-brand-logo-slot {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  html:has(.admin-dashboard-shell),
  body:has(.admin-dashboard-shell) {
    overflow: auto;
  }

  .admin-dashboard-shell {
    position: relative;
    inset: auto;
    height: auto;
    min-height: 100dvh;
    overflow: auto;
    padding: 22px 20px;
  }

  .admin-dashboard-header {
    --admin-brand-logo-width: 140px;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }

  .admin-stats-row {
    grid-template-columns: 1fr;
  }

  .admin-welcome-panel {
    padding: 24px 20px;
  }

  .admin-module-card {
    min-height: 98px;
  }
}

/* Keep Home button look, but never restyle alert/modal/dialog controls */
button:not(.btn-close):not(.custom-alert-toast-close):not(.custom-alert-modal-close):not([aria-label="Close"]):not([aria-label="Close notification"]):not(.student-hero__scroll):not(.student-hero__cta):not(.financial-aid-dialog__close):not(.financial-aid-btn):not(.financial-aid-nav__btn):not(.pending-fee-dialog__close):not(.pending-fee-upload__btn):not(.pending-fee-row__drop) {
  color: black !important;
  border-radius: 25px !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
}

.admin-dashboard-shell .logout-button {
  border-radius: 999px !important;
}

/* Preserve general table styling for other screens */
table {
  width: 90%;
  border-collapse: collapse;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
}

th,
td {
  padding: 8px 12px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
}

.container {
  margin: 0 auto;
  padding: 20px;
}

.footer {
  background-color: #f9e1be;
  color: black;
  text-align: center;
  height: 10vh;
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Home.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;uFAEqF;EACrF,oBAAoB;AACtB;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,qEAAqE;EACrE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gEAAgE;EAChE,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;EACpB,4DAA4D;EAC5D,gEAAgE;AAClE;;AAEA;EACE,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,SAAW;EACX,aAAa;EACb,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,8CAA8C;EAC9C,6EAA6E;EAC7E,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;IAC/B,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yEAAyE;AACzE;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qDAAqD;AACrD;EACE,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["html:has(.admin-dashboard-shell),\nbody:has(.admin-dashboard-shell) {\n  margin: 0;\n  overflow: hidden;\n  height: 100%;\n}\n\n.admin-home-root {\n  width: 100%;\n  height: 100%;\n}\n\n.admin-dashboard-shell {\n  --ops-sidebar-width: 280px;\n  position: fixed;\n  inset: 0;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, #f5f1eb 0%, #f8f7fb 30%, #eef4ff 100%);\n  padding: 28px 32px;\n  overflow: hidden;\n}\n\n.admin-dashboard-backdrop {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(circle at top left, rgba(245, 193, 193, 0.35), transparent 28%),\n    radial-gradient(circle at bottom right, rgba(175, 211, 255, 0.28), transparent 30%);\n  pointer-events: none;\n}\n\n.admin-dashboard-header,\n.admin-dashboard-content,\n.admin-footer {\n  position: relative;\n  z-index: 1;\n}\n\n.admin-dashboard-header {\n  --admin-brand-logo-width: 160px;\n  width: 100%;\n  flex: 0 0 auto;\n  margin: 0 0 12px;\n  padding: 0;\n  display: grid;\n  grid-template-columns: var(--ops-sidebar-width, 280px) minmax(0, 1fr);\n  gap: 14px;\n  align-items: center;\n}\n\n.admin-brand-logo-slot {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n}\n\n.admin-brand-logo {\n  width: var(--admin-brand-logo-width);\n  height: auto;\n  flex: 0 0 auto;\n  opacity: 0.95;\n}\n\n.admin-brand-label {\n  justify-self: start;\n  display: inline-flex;\n  align-items: center;\n  padding: 9px 16px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.7);\n  border: 1px solid rgba(152, 163, 192, 0.22);\n  color: #6a6283;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  backdrop-filter: blur(10px);\n}\n\n.logout-button {\n  border: none !important;\n  background: linear-gradient(135deg, #f2c4c4, #f9e1be) !important;\n  color: #2d2b36 !important;\n  border-radius: 999px !important;\n  padding: 12px 20px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  box-shadow: 0 10px 20px rgba(245, 180, 180, 0.28) !important;\n  transition: transform 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.logout-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 24px rgba(245, 180, 180, 0.34) !important;\n}\n\n.admin-dashboard-content {\n  width: 100%;\n  flex: 1 1 0;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin-dashboard-content > .ops-layout {\n  flex: 1 1 0;\n  min-height: 0;\n  height: 100%;\n}\n\n.admin-welcome-panel {\n  background: rgba(255, 255, 255, 0.7);\n  border: 1px solid rgba(143, 155, 175, 0.18);\n  border-radius: 28px;\n  padding: 32px 36px;\n  box-shadow: 0 20px 50px rgba(52, 62, 94, 0.08);\n  backdrop-filter: blur(12px);\n}\n\n.welcome-badge {\n  display: inline-block;\n  padding: 8px 14px;\n  border-radius: 999px;\n  background: rgba(213, 204, 253, 0.45);\n  color: #4d4a68;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 16px;\n}\n\n.admin-welcome-panel h1 {\n  margin: 0;\n  font-size: clamp(2.2rem, 3vw, 3.4rem);\n  line-height: 1.1;\n  letter-spacing: -0.04em;\n  color: #1f2430;\n}\n\n.admin-welcome-panel p {\n  margin: 14px 0 0;\n  color: #5e6475;\n  font-size: 1.02rem;\n  max-width: 720px;\n  line-height: 1.7;\n}\n\n.admin-stats-row {\n  margin-top: 26px;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(180px, 1fr));\n  gap: 18px;\n}\n\n.admin-stat-card {\n  background: rgba(255, 255, 255, 0.76);\n  border: 1px solid rgba(143, 155, 175, 0.15);\n  border-radius: 22px;\n  padding: 20px 22px;\n  box-shadow: 0 12px 26px rgba(58, 67, 88, 0.06);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 120px;\n}\n\n.admin-stat-card span {\n  color: #6b728a;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.admin-stat-card strong {\n  margin-top: 12px;\n  font-size: clamp(1.7rem, 2vw, 2.6rem);\n  color: #171d2c;\n  letter-spacing: -0.04em;\n}\n\n.admin-modules-section {\n  margin-top: 34px;\n}\n\n.admin-modules-heading h2 {\n  margin: 0;\n  font-size: 1.35rem;\n  color: #1f2430;\n  letter-spacing: -0.02em;\n}\n\n.admin-modules-heading p {\n  margin: 6px 0 0;\n  color: #7a758c;\n  font-size: 0.95rem;\n}\n\n.admin-card-grid {\n  margin-top: 18px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.admin-module-card {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  background: rgba(255, 255, 255, 0.82);\n  border: 1px solid rgba(143, 155, 175, 0.15);\n  border-radius: 24px;\n  padding: 18px 18px 18px 16px;\n  text-decoration: none;\n  box-shadow: 0 18px 32px rgba(32, 40, 56, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  min-height: 120px;\n}\n\n.admin-module-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 22px 36px rgba(32, 40, 56, 0.12);\n  text-decoration: none;\n}\n\n.admin-module-icon {\n  width: 62px;\n  height: 62px;\n  border-radius: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  box-shadow: inset 0 1px 1px rgba(255,255,255,0.25), 0 10px 18px rgba(0,0,0,0.08);\n}\n\n.admin-module-icon i {\n  font-size: 1.7rem;\n  color: #ffffff;\n}\n\n.admin-module-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-module-text h3 {\n  margin: 0 0 6px;\n  font-size: 1.12rem;\n  color: #1f2430;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.admin-module-text p {\n  margin: 0;\n  font-size: 0.78rem;\n  color: #757d8b;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.admin-module-arrow {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f4f9;\n  color: #32384a;\n  font-size: 0.9rem;\n  bottom: 0;\n}\n\n.admin-footer {\n  max-width: 1320px;\n  margin: 0 auto;\n  padding: 10px 0 16px;\n  text-align: center;\n}\n\n.admin-footer p {\n  margin: 0;\n  color: #6c757d;\n  font-size: 0.85rem;\n}\n\n@media (max-width: 1100px) {\n  .admin-dashboard-header {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 14px;\n  }\n\n  .admin-brand-logo-slot {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 768px) {\n  html:has(.admin-dashboard-shell),\n  body:has(.admin-dashboard-shell) {\n    overflow: auto;\n  }\n\n  .admin-dashboard-shell {\n    position: relative;\n    inset: auto;\n    height: auto;\n    min-height: 100dvh;\n    overflow: auto;\n    padding: 22px 20px;\n  }\n\n  .admin-dashboard-header {\n    --admin-brand-logo-width: 140px;\n    flex-wrap: wrap;\n    margin-bottom: 12px;\n  }\n\n  .admin-stats-row {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-welcome-panel {\n    padding: 24px 20px;\n  }\n\n  .admin-module-card {\n    min-height: 98px;\n  }\n}\n\n/* Keep Home button look, but never restyle alert/modal/dialog controls */\nbutton:not(.btn-close):not(.custom-alert-toast-close):not(.custom-alert-modal-close):not([aria-label=\"Close\"]):not([aria-label=\"Close notification\"]):not(.student-hero__scroll):not(.student-hero__cta):not(.financial-aid-dialog__close):not(.financial-aid-btn):not(.financial-aid-nav__btn):not(.pending-fee-dialog__close):not(.pending-fee-upload__btn):not(.pending-fee-row__drop) {\n  color: black !important;\n  border-radius: 25px !important;\n  font-weight: 600 !important;\n  font-size: 0.9rem !important;\n}\n\n.admin-dashboard-shell .logout-button {\n  border-radius: 999px !important;\n}\n\n/* Preserve general table styling for other screens */\ntable {\n  width: 90%;\n  border-collapse: collapse;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 20px;\n}\n\nth,\ntd {\n  padding: 8px 12px;\n  text-align: left;\n  border: 1px solid #ddd;\n}\n\nth {\n  background-color: #f2f2f2;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.footer {\n  background-color: #f9e1be;\n  color: black;\n  text-align: center;\n  height: 10vh;\n  font-size: 0.8rem;\n  font-weight: 600;\n  display: flex;\n  border-top-left-radius: 25px;\n  border-top-right-radius: 25px;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
